// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { getMe } from '../utils/api';

// const AuthContext = createContext(null);

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const token = localStorage.getItem('admin_token');
//     if (token) {
//       getMe()
//         .then(res => setUser(res.data.user))
//         .catch(() => {
//           localStorage.removeItem('admin_token');
//           localStorage.removeItem('admin_user');
//         })
//         .finally(() => setLoading(false));
//     } else {
//       setLoading(false);
//     }
//   }, []);

//   const loginUser = (token, userData) => {
//     localStorage.setItem('admin_token', token);
//     localStorage.setItem('admin_user', JSON.stringify(userData));
//     setUser(userData);
//   };

//   const logoutUser = () => {
//     localStorage.removeItem('admin_token');
//     localStorage.removeItem('admin_user');
//     setUser(null);
//   };

//   return (
//     <AuthContext.Provider value={{ user, loading, loginUser, logoutUser, setUser }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe, logout as logoutApi } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      getMe()
        .then(r => setUser(r.data.user))
        .catch(() => {
          localStorage.removeItem('admin_token');
          localStorage.removeItem('admin_user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const loginUser = (token, userData) => {
    localStorage.setItem('admin_token', token);
    localStorage.setItem('admin_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logoutUser = async () => {
    try { await logoutApi(); } catch {}
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginUser, logoutUser, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);